export const successTickGhost = (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M9.99935 18.3332C14.5827 18.3332 18.3327 14.5832 18.3327 9.99984C18.3327 5.4165 14.5827 1.6665 9.99935 1.6665C5.41602 1.6665 1.66602 5.4165 1.66602 9.99984C1.66602 14.5832 5.41602 18.3332 9.99935 18.3332Z" stroke="#18B777" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.45898 9.99981L8.81732 12.3581L13.5423 7.64148" stroke="#18B777" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
    );
  };
  